import SvgIcoWindows from './SvgIcoWindows';

export default SvgIcoWindows;
